var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.403v14H2v-14h14zm0-2H2c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L6 10.543l-3 3.86h12l-3.86-5.14z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTYgMi40MDMzMlYxNi40MDMzSDJWMi40MDMzMkgxNlpNMTYgMC40MDMzMkgyQzAuOSAwLjQwMzMyIDAgMS4zMDMzMiAwIDIuNDAzMzJWMTYuNDAzM0MwIDE3LjUwMzMgMC45IDE4LjQwMzMgMiAxOC40MDMzSDE2QzE3LjEgMTguNDAzMyAxOCAxNy41MDMzIDE4IDE2LjQwMzNWMi40MDMzMkMxOCAxLjMwMzMyIDE3LjEgMC40MDMzMiAxNiAwLjQwMzMyWk0xMS4xNCA5LjI2MzMyTDguMTQgMTMuMTMzM0w2IDEwLjU0MzNMMyAxNC40MDMzSDE1TDExLjE0IDkuMjYzMzJaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjYiLz4KPC9zdmc+Cg==";
export { SvgImg as ReactComponent };